export default {"src":"/_next/static/media/icon_store_v2_z_stretched.8351f303.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};